import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableBalanceAdjustmentsView.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // Main data table for balance adjustments
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 70,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for details column
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                                    },
                                },
                                {
                                    id: 'UserId',
                                    header: _('ID Usuario'), // Header for User ID column
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Header for Date column
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'UserName',
                                    header: _('Nombre Usuario'), // Header for User Name column
                                    width: 250,
                                    sort: 'int', // Sorting type
                                    hidden: !devConfig.getPermAction(
                                        'sensitiveInformationNames',
                                        'Add', // Conditional visibility based on permissions
                                    ),
                                },
                                {
                                    id: 'Currency',
                                    header: _('Moneda'), // Header for Currency column
                                    width: 80,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocalDate',
                                    header: _('Fecha de creación'), // Header for Created Date column
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'AmountDeposit',
                                    header: _('Saldo recargas'), // Header for Deposit Amount column
                                    width: 150,
                                    sort: 'int', // Sorting type
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2, // Number formatting options
                                    }),
                                },
                                {
                                    id: 'AmountWithdraw',
                                    header: _('Saldo retiros'), // Header for Withdraw Amount column
                                    width: 150,
                                    sort: 'int', // Sorting type
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2, // Number formatting options
                                    }),
                                },
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('resume:id', [
                                        item.UserId, // Trigger event with User ID
                                    ]);
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('detailsCasino').show(); // Show details for small screens
                                    } else {
                                        $$('dColl').expand(); // Expand details section
                                        $$('formDetails').clear(); // Clear details form
                                        $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                    }
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay before data load
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID for pagination
                        },
                        {
                            type: 'wide',
                            view: 'datatable', // Secondary data table for balance adjustments
                            id: 'datatable2', // Unique identifier for the second datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 70,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for details column
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                                    },
                                },
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Header for Date column
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'Currency',
                                    header: _('Moneda'), // Header for Currency column
                                    width: 80,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AmountDeposit',
                                    header: _('Saldo recargas'), // Header for Deposit Amount column
                                    width: 150,
                                    sort: 'int', // Sorting type
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2, // Number formatting options
                                    }),
                                },
                                {
                                    id: 'AmountWithdraw',
                                    header: _('Saldo retiros'), // Header for Withdraw Amount column
                                    width: 150,
                                    sort: 'int', // Sorting type
                                    format: webix.Number.numToStr({
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2, // Number formatting options
                                    }),
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay before data load
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('resume:id', [
                                        item.UserId, // Trigger event with User ID
                                    ]);
                                },
                            },
                            ready: function () {
                                if (!datatable2.count()) {
                                    webix.extend(datatable2, webix.OverlayBox); // Extend with overlay functionality
                                    datatable2.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerB', // Pager ID for pagination
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The main datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the main datatable
        var url = devConfig.geturlApi() + 'Report/GetBalanceUsers'; // API endpoint for fetching balance users
        var filter = ''; // Filter string for API requests
        var grid2 = $$('datatable2'); // Reference to the secondary datatable
        grid2.hide(); // Initially hide the second datatable
        $$('toolbar').hide(); // Initially hide the toolbar

        // Event listener for filtering balance adjustments
        this.on(this.app, 'balanceAdjustments:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for API request
            var typeTable = 0; // Type of table to display (0 or 1)

            // Loop through filter data to build query string
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    if (object[i][1] == 0) {
                    } else {
                        typeTable = 1; // Set typeTable based on filter
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to query string
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to query string
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Show/hide datatables based on typeTable
            if (typeTable == 0) {
                grid.show(); // Show main grid
                grid2.hide(); // Hide secondary grid
                grid.clearAll(); // Clear previous data
                grid.load(
                    url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters
                );
                $$('toolbar').show(); // Show toolbar for main grid
                $$('toolbar2').hide(); // Hide toolbar for secondary grid
            } else {
                grid2.show(); // Show secondary grid
                grid.hide(); // Hide main grid
                grid2.clearAll(); // Clear previous data
                grid2.load(
                    url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters
                );
                $$('toolbar2').show(); // Show toolbar for secondary grid
                $$('toolbar').hide(); // Hide toolbar for main grid
            }
            grid.clearAll(); // Clear main grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter string
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger event with User ID
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });

        // Popup window for adding adjustments
        var popupAdd = webix.ui({
            view: 'window',
            id: 'AddAdjustments', // Unique identifier for the popup
            width: 450,
            height: 450,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Ajustar Saldo'), // Label for the popup header
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup on icon click
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Make the popup modal
            body: {
                view: 'form',
                id: 'addform', // Unique identifier for the form
                elements: [
                    {
                        view: 'text',
                        label: _('Usuario Id:'), // Label for User ID input
                        name: 'UserId',
                        labelWidth: 150,
                        type: 'number',
                        required: true, // Mark as required
                    },
                    {
                        view: 'combo',
                        label: _('Tipo Saldo:'), // Label for Balance Type input
                        name: 'TypeBalance',
                        required: true, // Mark as required
                        options: [
                            { id: '0', value: _('Saldo recargas') }, // Option for Deposit
                            { id: '1', value: _('Saldo retiros') }, // Option for Withdraw
                        ],
                        labelWidth: 150,
                    },
                    {
                        view: 'text',
                        label: _('Monto:'), // Label for Amount input
                        name: 'Amount',
                        type: 'number',
                        labelWidth: 150,
                        required: true, // Mark as required
                    },
                    {
                        view: 'textarea',
                        label: _('Descripción:'), // Label for Description input
                        name: 'Description',
                        labelWidth: 150,
                        required: true, // Mark as required
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Close popup on cancel
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for AJAX request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'BalanceAdjustments/Adjustment', // API endpoint for saving adjustments
                                                '{"UserId":"' +
                                                    values.UserId +
                                                    '", "TypeBalance":"' +
                                                    values.TypeBalance +
                                                    '", "Amount":"' +
                                                    values.Amount +
                                                    '", "Description":"' +
                                                    values.Description +
                                                    '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Show error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response JSON
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: '¡Error!',
                                                                type: 'alert-error',
                                                                text: json.AlertMessage, // Show alert message on error
                                                            });
                                                        } else {
                                                            webix.message(
                                                                'Saldo Ajustado', // Show success message
                                                            );
                                                            grid.clearAll(); // Clear main grid
                                                            grid.load(
                                                                url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload data
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Close popup
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Show validation error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate form on change
                        },
                    },
                },
            },
        });

        // Event listener for showing the add adjustment popup
        this.on(this.app, 'addAdjustment:button', (filter) => {
            popupAdd.show(); // Show the popup
        });
    }
}

// FILE DOCUMENTED
